import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ChevronUp } from "lucide-react";
import Navigation from "./Navigation";
import Footer from "./Footer";
import ContactStrip from "./ContactStrip";

const Layout = ({ children, showContactStrip = true }) => {
  const [showGoToTop, setShowGoToTop] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setShowGoToTop(window.scrollY > 500);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Scroll to top instantly on route change (no animation)
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />
      <main className="flex-grow">{children}</main>
      {showContactStrip && <ContactStrip />}
      <Footer />

      {/* Go to Top Button */}
      <button
        onClick={scrollToTop}
        className={`go-to-top ${showGoToTop ? "visible" : ""}`}
        aria-label="Отидете нагоре"
        data-testid="go-to-top-btn"
      >
        <ChevronUp className="w-6 h-6" />
      </button>
    </div>
  );
};

export default Layout;
